import React, { useMemo } from 'react';
import { cn } from '../../utils/cn';
import type { MenuItemProps } from './menu-item.types';
import styles from './menu-item.module.css';
import Text from '../../atoms/text';

export const useMenuItemStyles = ({
    label,
    labelProps,
    leadingIconProps,
    trailingIconProps,
    containerClassName,
    leftContainerClassName,
    rightContainerClassName,
}: Pick<
    MenuItemProps,
    | 'label'
    | 'labelProps'
    | 'leadingIconProps'
    | 'trailingIconProps'
    | 'containerClassName'
    | 'leftContainerClassName'
    | 'rightContainerClassName'
>) => {
    const leftContainerClassNames = useMemo(() => cn(styles.left, leftContainerClassName), [leftContainerClassName]);

    const leadingIconClassNames = useMemo(
        () => cn(styles.leftIcon, leadingIconProps?.className),
        [leadingIconProps?.className]
    );

    const labelContainerClassNames = useMemo(() => cn(styles.leftText, labelProps?.className), [labelProps?.className]);

    const rightContainerClassNames = useMemo(
        () => cn(styles.right, rightContainerClassName),
        [rightContainerClassName]
    );

    const trailingIconClassNames = useMemo(
        () => cn(styles.rightIcon, trailingIconProps?.className),
        [trailingIconProps?.className]
    );

    const containerClassNames = useMemo(() => cn(styles.container, containerClassName), [containerClassName]);

    const labelContent = useMemo(() => {
        if (!label) return null;

        if (typeof label === 'string') {
            return (
                <Text {...labelProps} className={labelContainerClassNames}>
                    {label}
                </Text>
            );
        }

        return <div className={labelContainerClassNames}>{label}</div>;
    }, [label, labelProps, labelContainerClassNames]);

    return {
        containerClassNames,
        leftContainerClassNames,
        leadingIconClassNames,
        labelContainerClassNames,
        rightContainerClassNames,
        trailingIconClassNames,
        labelContent,
    };
};
